import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(() => ({
  icon: {
    width: '100%',
    height: 'auto',
    objectFit: 'contain',
  },
  iconWrapper: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'center',
    flexShrink: 0,
    width: '2.625rem',
  },
  item: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '1rem',
    '&:first-child img': {
      width: '2rem',
    },
  },
}));
